import { render, staticRenderFns } from "./PaymentMethodSidebar.vue?vue&type=template&id=7973bcf6&scoped=true&"
import script from "./PaymentMethodSidebar.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodSidebar.vue?vue&type=style&index=0&id=7973bcf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973bcf6",
  null
  
)

export default component.exports